module.exports = __webpack_public_path__ + "img/brokerIcon.f37db269.png";